export default __webpack_public_path__ + "static/media/fieldhockey.f5a7c1c1.jpg";